module.exports = __webpack_public_path__ + "static/media/parceiros-img.1992e093.jpg";